/**
 * An organization the viewer can create an Account Issue in. Selecting it resolves
 * to the org's designated repository (`repositoryOwner`/`repositoryName`).
 */
export interface OrgRepositoryPickerOrganization {
  login: string
  name: string
  avatarUrl: string
  repositoryOwner: string
  repositoryName: string
}

/** Minimal repository shape the picker needs to render and return a selection. */
export interface OrgRepositoryPickerRepository {
  id: string
  name: string
  nameWithOwner: string
  ownerLogin: string
  isPrivate: boolean
}

/** Discriminated union so consumers get an unambiguous org-or-repo result. */
export type OrgRepositoryPickerSelection =
  | {kind: 'org'; organization: OrgRepositoryPickerOrganization}
  | {kind: 'repo'; repository: OrgRepositoryPickerRepository}

export type OrgRepositoryPickerItem =
  | {kind: 'org'; key: string; organization: OrgRepositoryPickerOrganization}
  | {kind: 'repo'; key: string; repository: OrgRepositoryPickerRepository}

export function organizationItemKey(org: OrgRepositoryPickerOrganization): string {
  return `org:${org.login}`
}

export function repositoryItemKey(repo: OrgRepositoryPickerRepository): string {
  return `repo:${repo.id}`
}

export function selectionFromItem(item: OrgRepositoryPickerItem): OrgRepositoryPickerSelection {
  return item.kind === 'org'
    ? {kind: 'org', organization: item.organization}
    : {kind: 'repo', repository: item.repository}
}
